let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7IkIt")).then(() => parcelRequire('6Tbkh'));